import { Fill } from 'nano-slots';
import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';
import { useDrawerStackItem } from './DrawerStackItemContext';

export default function DrawerStackConciliatedBadge(props) {
    const { children, className } = props;
    const { isActive } = useDrawerStackItem();

    if (!isActive) {
        return null;
    }

    return (
        <Fill name="drawer-stack-title-badge">
            <span className={cn('ml-3', className)}>{children}</span>
        </Fill>
    );
}

DrawerStackConciliatedBadge.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};
